// authSlice.js
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  addressCityName: "",
  addressStateName: "",
  balance: "",
  birthYear: "",
  specialAbilityDetails: "",
  detailedAddress: "",
  email: "",
  educationLevelType: "",
  educationDetails: "",
  familyRelationType: "",
  fullName: "",
  genderType: "",
  gotraType: "",
  heightFeetType: "",
  heightInchesType: "",
  id: "",
  isEmailVerified: "",
  incomeSourceDetails: "",
  yearlyIncome: "",
  isPhoneVerified: "",
  isSpeciallyAbled: "",
  isPureVegetarian: "",
  language: "",
  lastPendingPhoneOtpTimestamp: "",
  maritalStatusType: "",
  otherDetails: "",
  ownerUserId: "",
  pendingEmail: "",
  pendingPhone: "",
  pendingPhoneVerifyAttempts: "",
  phone: "",
  phoneOtpSentCount: "",
  profileImageUrl: "",
  role: "",
  verificationStatus: "",
  weightRangeType: "",
  isLoading: "",
};
const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: initialState,
  reducers: {
    fetchProfileStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchProfileSuccess(state, action) {
      console.log("In fetchProfileSuccess, action =", action);
      const {
        addressCityName,
        addressStateName,
        birthYear,
        balance,
        specialAbilityDetails,
        detailedAddress,
        email,
        educationLevelType,
        educationDetails,
        familyRelationType,
        fullName,
        genderType,
        gotraType,
        heightFeetType,
        heightInchesType,
        id,
        isEmailVerified,
        incomeSourceDetails,
        yearlyIncome,
        isPhoneVerified,
        isSpeciallyAbled,
        isPureVegetarian,
        language,
        lastPendingPhoneOtpTimestamp,
        maritalStatusType,
        otherDetails,
        ownerUserId,
        pendingEmail,
        pendingPhone,
        pendingPhoneVerifyAttempts,
        phone,
        phoneOtpSentCount,
        profileImageUrl,
        role,
        verificationStatus,
        weightRangeType,
      } = action.payload;

      state.addressCityName = addressCityName;
      state.addressStateName = addressStateName;
      state.balance = balance;
      state.birthYear = birthYear;
      state.specialAbilityDetails = specialAbilityDetails;
      state.detailedAddress = detailedAddress;
      state.email = email;
      state.educationDetails = educationDetails;
      state.educationLevelType = educationLevelType;
      state.familyRelationType = familyRelationType;
      state.fullName = fullName;
      state.genderType = genderType;
      state.gotraType = gotraType;
      state.heightFeetType = heightFeetType;
      state.heightInchesType = heightInchesType;
      state.id = id;
      state.isEmailVerified = isEmailVerified;
      state.incomeSourceDetails = incomeSourceDetails;
      state.yearlyIncome = yearlyIncome;
      state.isPhoneVerified = isPhoneVerified;
      state.isSpeciallyAbled = isSpeciallyAbled;
      state.isPureVegetarian = isPureVegetarian;
      state.language = language;
      state.lastPendingPhoneOtpTimestamp = lastPendingPhoneOtpTimestamp;
      state.maritalStatusType = maritalStatusType;
      state.otherDetails = otherDetails;
      state.ownerUserId = ownerUserId;
      state.pendingEmail = pendingEmail;
      state.pendingPhone = pendingPhone;
      state.pendingPhoneVerifyAttempts = pendingPhoneVerifyAttempts;
      state.phone = phone;
      state.phoneOtpSentCount = phoneOtpSentCount;
      state.profileImageUrl = profileImageUrl;
      state.role = role;
      state.verificationStatus = verificationStatus;
      state.weightRangeType = weightRangeType;
      state.isLoading = false;
    },
    fetchProfileFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearProfile(state, action) {
      console.log("in CLEARPROFILE...........");
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });
    },
    updateBalance(state, action) {
      console.log("In update balance. state=", state, ",   action=", action);
      state.balance = action.payload.balance;
    },
  },
});

export default userProfileSlice.reducer;
export const {
  clearProfile,
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  updateBalance,
} = userProfileSlice.actions;
